import { AudioMessageKeyEnum, ELEVENLABS_CONFIG } from '@cibli/shared';

import api from '@/services/api.ts';

/**
 * Creates a Blob with the correct MIME type for PCM16 audio
 * Speaker.playAudio() expects PCM16 format
 */
function createAudioBlob(data: Blob | unknown): Blob {
  if (data instanceof Blob) {
    return data.type === ELEVENLABS_CONFIG.AUDIO_CONTENT_TYPE
      ? data
      : new Blob([data], { type: ELEVENLABS_CONFIG.AUDIO_CONTENT_TYPE });
  }
  return new Blob([data as BlobPart], { type: ELEVENLABS_CONFIG.AUDIO_CONTENT_TYPE });
}

export const getAudioMessage = async (
  message: AudioMessageKeyEnum,
  signal?: AbortSignal,
  params?: Record<string, string>,
): Promise<Blob> => {
  const searchParams = new URLSearchParams();
  searchParams.set('messageKey', message);
  if (params) {
    searchParams.set('params', JSON.stringify(params));
  }

  const response = await api.get<Blob>(`/audio/message?${searchParams.toString()}`, {
    responseType: 'blob',
    signal,
  });

  return createAudioBlob(response);
};
